import { Spin } from "antd";
import React from "react";
import {
  CustomerTransaction,
  Loading,
} from "../../../helpers/shared-interfaces";
import { formatter } from "../../../helpers/utilities";
import { ItemClickProps } from "../GlobalFormModal";
import NoData from "../NoData";

type Props = {
  loading: Loading;
  handleRetry: () => void;
  onlineTransactions: CustomerTransaction[];
  onTransactionClick: (item: ItemClickProps) => void;
};

export default function OnlineTransactions({
  onlineTransactions,
  loading,
  handleRetry,
  onTransactionClick,
}: Props): JSX.Element {
  return (
    <div className="global-results">
      {loading === Loading.INITIAL ? null : loading === Loading.LOADING ? (
        <div className="loading-container">
          <div className="loading-spinner">
            <Spin size="default" />
          </div>
        </div>
      ) : loading === Loading.ERROR ? (
        <div className="error-container">
          <p>Something went wrong</p>
          <button onClick={handleRetry}>Try again</button>
        </div>
      ) : onlineTransactions.length === 0 ? (
        <div className="no-results">
          <NoData />
          <p>No Data</p>
        </div>
      ) : (
        onlineTransactions.map((transaction) => (
          <div
            key={transaction.id}
            className="search-result"
            role="presentation"
            onClick={() =>
              onTransactionClick({
                id: transaction.id,
                type: "transaction",
                segment: "online-transactions",
                data: transaction,
              })
            }
          >
            <div className="result-content">
              <div className="result-title">
                {transaction.customer.fullname}
              </div>
              <div className="result-details">
                {transaction.customerSubscription?.product?.name} {" ~ "}{" "}
                {formatter.format(transaction.totalAmount)}
              </div>
            </div>
            <span className="right-arrow">→</span>
          </div>
        ))
      )}
    </div>
  );
}
